import { ReactNode, useState } from "react";
import { SxProps, Theme } from "@mui/material";

import Box from "@mui/material/Box";
import CardMedia from "@mui/material/CardMedia";

import {
  allowedFileTypes,
  getFileExtensionFromSignedUrl,
} from "../../../../../common/components/media/fileHelper";
import TableCellWithPhotoIconOnHover from "../../../../../common/components/table/TableCellWithPhotoIconOnHover";
import TableCellWithVideocamIconOnHover from "../../../../../common/components/table/TableCellWithVideocamIconOnHover";
import { DEFAULT_MEDIA_ICON_STYLES } from "../../../../../common/variables/common";
import MediaStatus from "../../../../../common/components/media/MediaStatus";

interface RecentEventsHoverIconsProps {
  keyFrame: string;
  mediaOutput: string;
  onClick?: () => void;
  rootSx?: SxProps<Theme>;
  imgWidth?: number;
  imgHeight?: number;
  errorFallback?: ReactNode;
}

const RecentEventsHoverIcons = ({
  keyFrame,
  mediaOutput,
  onClick,
  rootSx,
  imgWidth = 120,
  imgHeight = 90,
  errorFallback = null,
}: RecentEventsHoverIconsProps) => {
  const [error, setError] = useState(!keyFrame && !mediaOutput);

  const fileExtension = getFileExtensionFromSignedUrl(mediaOutput);

  const isVideo = allowedFileTypes.videos.includes(fileExtension);

  const s3Key = keyFrame ?? mediaOutput;

  const fallback = errorFallback || (
    <MediaStatus
      mediaStatusSx={{
        "& .MuiTypography-root": {
          fontSize: "75%",
        },
      }}
      variant="keyframeError"
    />
  );

  const handleMediaCardError = () => {
    setError(true);
  };

  return (
    <Box
      position="relative"
      sx={
        [
          {
            "& .hoverIcons": {
              display: "none",
              flex: 1,
              cursor: "pointer",
            },
            "&:hover .hoverIcons": {
              display: "flex",
              flex: 1,
              gap: "0.75em",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            },
            "& .videocamIcon": {
              zIndex: 1,
            },
          },
          rootSx,
        ].filter(Boolean) as SxProps<Theme>
      }
    >
      <Box className="hoverIcons">
        <TableCellWithPhotoIconOnHover
          className="photoIcon"
          onClick={onClick}
        />
        {isVideo && (
          <TableCellWithVideocamIconOnHover className="videocamIcon" />
        )}
      </Box>
      <Box
        sx={{
          ...DEFAULT_MEDIA_ICON_STYLES,
        }}
        onClick={onClick}
      >
        {error ? (
          fallback
        ) : (
          <CardMedia
            sx={{
              height: DEFAULT_MEDIA_ICON_STYLES.height,
              width: DEFAULT_MEDIA_ICON_STYLES.width,
            }}
            src={s3Key}
            width={imgWidth}
            height={imgHeight}
            component="img"
            onError={handleMediaCardError}
          />
        )}
      </Box>
    </Box>
  );
};

export default RecentEventsHoverIcons;
